// Capa HTTP de invitaciones (rutas PÚBLICAS, sin sesión): validar el enlace
// que llega por correo y aceptar la invitación definiendo la contraseña.

import { apiFetch } from "./api";

export interface InvitacionValida {
  email: string;
  first_name: string;
  expires_at: string;
}

export interface AceptarInvitacionInput {
  token: string;
  email: string;
  password: string;
  password_confirmation: string;
}

export async function validarInvitacion(token: string, email: string): Promise<InvitacionValida> {
  const { data } = await apiFetch<{ data: InvitacionValida }>(
    `/api/invitations/${encodeURIComponent(token)}?email=${encodeURIComponent(email)}`,
  );
  return data;
}

export function aceptarInvitacionRequest(input: AceptarInvitacionInput): Promise<{ message: string }> {
  return apiFetch<{ message: string }>("/api/invitations/accept", {
    method: "POST",
    body: JSON.stringify(input),
  });
}
